import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import get from 'lodash/get';

import { LanguageCode } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import Article from '~/ui/components/layouts/Article';
import { getRoutePostLink, generateLinkComponents } from '~/utils/blog';
import { postData } from '~/constants/blog';

const Post3 = (): ReactElement => {
  const { t: tArticle } = useTranslation('', { keyPrefix: '$local.$articles.$article3' });
  const { t: tNext } = useTranslation('', { keyPrefix: '$local.$articles.$article4' });

  const router = useRouter();
  const locale = router.locale as LanguageCode;

  const currentPostId = 3;
  const lastPostId = 4;

  let lastPostUrl = get(postData, [lastPostId, 'urls', locale]);
  lastPostUrl = getRoutePostLink(lastPostUrl, locale);

  const articleData = {
    id: currentPostId,
    hero: {
      heading: tArticle('title'),
      text: tArticle('subTitle'),
    },
    last: {
      url: lastPostUrl,
      id: lastPostId,
      heading: (
        <Trans
          i18nKey="title"
          t={tNext}
          components={{
            sup: <sup />,
          }}
        />
      ),
      text: (
        <Trans
          i18nKey="subTitleCopy"
          t={tNext}
          components={{
            sup: <sup />,
          }}
        />
      ),
      cta: tArticle('nextCta'),
    },
  };

  return (
    <Article id={articleData.id} hero={articleData.hero} last={articleData.last}>
      <h2>{tArticle('paragraphTitle1')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText1"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle2')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText2"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 3, 16),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle3')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText3"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 17, 17),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle4')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText4"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 11, 11),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle5')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText5"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 18, 18),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle6')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText6"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 11, 11),
          }}
        />
      </p>
      <p className="closing">{tArticle('paragraphText7')}</p>
    </Article>
  );
};

export default Post3;
